<template>
  <section class="co-bg-striped">
    <div class="co-container-md px-4 py-20 text-center">
      <h3 class="co-display-12 divider mb-5 text-center">
        <span>
          セットは最大
          <span class="co-display-10 font-bold text-co-danger-500">{{ $addComma(maxBargainPrice) }}</span>
          円もお得！
        </span>
      </h3>
      <div class="flex flex-col justify-center gap-8 sm:flex-row">
        <TeCourseSetBannerWebdevelopmentAdvancedjob />
        <TeCourseSetBannerFirstSidejobWebdesign />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import TeCourseSetBannerWebdevelopmentAdvancedjob from '~/components/Te/TeCourse/SetBanner/TeCourseSetBannerWebdevelopmentAdvancedjob.vue'
import TeCourseSetBannerFirstSidejobWebdesign from '~/components/Te/TeCourse/SetBanner/TeCourseSetBannerFirstSidejobWebdesign.vue'

const options = {
  props: {
    course: {
      type: Object,
    },
  },
  filters: {
    addComma(value: number | string) {
      return value.toLocaleString()
    },
  },
  computed: {
    maxBargainPrice(): number | '-' {
      if (this.course) {
        const bargainPriceArray = this.course.attributes.packs.map((p: any) => {
          return p.bargain_price
        })
        if (bargainPriceArray.length !== 0) {
          return bargainPriceArray.reduce((a: any, b: any) => {
            return Math.max(a, b)
          })
        } else {
          return 0
        }
      } else {
        return '-'
      }
    },
  },
  components: {
    TeCourseSetBannerWebdevelopmentAdvancedjob,
    TeCourseSetBannerFirstSidejobWebdesign,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
/* 線のスタイル */
.divider::before,
.divider::after {
  @apply bg-[#a1a1a1] h-px;
}
</style>
